import { SseClient } from "../SseClient";
import type { SseClientOptions } from "../SseClient";

/**
 * Композиционный корень SSE-подписок: единственное место, где выбирается
 * реализация потока событий. Экранные хуки просят подписку здесь и получают
 * уже собранный клиент, поэтому подмена транспорта событий делается в одном
 * файле, а не в каждом хуке.
 */
export function createSseClient(options: SseClientOptions): SseClient {
  return new SseClient(options);
}
